export const safeGet = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      ...options,
    });

    const status = response.status;
    let payload = null;

    try {
      payload = await response.json();
    } catch (parseError) {
      payload = null;
    }

    if (response.ok) {
      return {
        ok: true,
        reason: "OK",
        status,
        data: payload,
        error: null,
      };
    }

    if (status === 404) {
      return {
        ok: false,
        reason: "NOT_FOUND",
        status,
        data: null,
        error: null,
      };
    }

    return {
      ok: false,
      reason: "HTTP_ERROR",
      status,
      data: null,
      error: payload || { message: `HTTP error ${status}` },
    };
  } catch (error) {
    return {
      ok: false,
      reason: "NETWORK_ERROR",
      status: 0,
      data: null,
      error,
    };
  }
};



